import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "1.0px",
			strokeMiterlimit: 10
		},
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M2,2h20v20h-20z" }),
			/* @__PURE__ */ _jsx("path", { d: "M2,7l20,0" }),
			/* @__PURE__ */ _jsx("path", { d: "M2,12l20,0" }),
			/* @__PURE__ */ _jsx("path", { d: "M2,17l20,0" }),
			/* @__PURE__ */ _jsx("path", { d: "M13,2l0,5" }),
			/* @__PURE__ */ _jsx("path", { d: "M7.5,7l0,5" }),
			/* @__PURE__ */ _jsx("path", { d: "M16.5,7l0,5" }),
			/* @__PURE__ */ _jsx("path", { d: "M11,12l0,5" }),
			/* @__PURE__ */ _jsx("path", { d: "M7.5,17l0,5" }),
			/* @__PURE__ */ _jsx("path", { d: "M16.5,17l0,5" })
		]
	})
});
export default SvgWall;
